import {Principal} from '@icp-sdk/core/principal';

export const CMC_ID = Principal.fromText('rkp4c-7iaaa-aaaaa-aaaca-cai');

export const ICP_LEDGER_ID = Principal.fromText('ryjl3-tyaaa-aaaaa-aaaba-cai');
